var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h6',[_vm._v("Производится импорт...")]),_c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"loader-5"})])])
}]

export { render, staticRenderFns }